//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import useWindowSize from "hooks/useWindowSize";
//css
import "pages/styles/dashboard/P2Pv2.css";
import { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import P2pBuyTrades from "./Components/P2pv2buy";
import P2pSellTrades from "./Components/P2pv2sell";

const P2pv2 = (props) => {
  const history = useHistory();
  const [tradeType, setTradeType] = useState("buy");
  const windowSize = useWindowSize();
  const [showCreateLink, setShowCreateLink] = useState(windowSize.width < 760);

  useEffect(() => {
    if(windowSize?.width) {
      if(windowSize.width < 800) {
        setShowCreateLink(false);
      } else {
        setShowCreateLink(true)
      }
    }
  
  }, [windowSize?.width])

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const handleTradeType = (type) => {
    setTradeType(type);
    searchParams.set("type", type);
    history.replace(`${location.pathname}?${searchParams.toString()}`);
  };

  useEffect(() => {
    if (!searchParams.has("type")) {
      searchParams.set("type", tradeType);
      history.replace(`${location.pathname}?${searchParams.toString()}`);
    } else {
      handleTradeType(searchParams.get("type"));
    }

    // eslint-disable-next-line
  }, [tradeType]);

  const currentPage = "P2P";
  return (
    <div>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />
      <section className="p2p">
        <div className="p2p-container">
          <div className="p2p-container__header">
            <h1 className="p2p2-title"> P2P <span className={`sm-ft ${tradeType === "buy" ? "sell-listings": "buy-listings"}` }>{tradeType === "buy" ? "- Sell": "- Buy"} Listings</span></h1>
            {!showCreateLink ? <Link to={`/dashboard/p2p/create?${searchParams.toString()}`}>
                <button className="p2p2-btn1"> Create listing </button>
              </Link> : null}
          </div>
          <div className="p2p2-content">
            <div className="p2p2-topbox">
              <div className="p2p2-tabs">
                <div
                  className={`p2p2-tab ${
                    tradeType === "buy" ? "p2-active" : ""
                  }`}
                  onClick={(e) => handleTradeType("buy")}
                >
                  <span className="bold">Buy</span>
                </div>
                <div
                  className={`p2p2-tab ${
                    tradeType === "sell" ? "p2-active" : ""
                  }`}
                  onClick={(e) => handleTradeType("sell")}
                >
                  <span className="bold">Sell</span>
                </div>
              </div>
              {showCreateLink ? <Link to={`/dashboard/p2p/create?${searchParams.toString()}`}>
                <button className="p2p2-btn1"> Create listing </button>
              </Link> : null}
            </div>
            {tradeType === "buy" ? (
              <P2pBuyTrades searchParams={searchParams} {...props} />
            ) : (
              <P2pSellTrades searchParams={searchParams} {...props} />
            )}
          </div>
        </div>
      </section>

      <style jsx>
        {`
          .lavender {
            color: lavender;
          }
          .sm-ft {
            font-size: 16px;
          }
          .sell-listings {
            // color: #ED2E7E;
          }
          .buy-listings {
            // color: #03A438;
          }
          .p2p-container__header {
            display: flex;
            justify-content: space-between
          }
        `}
      </style>
    </div>
  );
};

export default P2pv2;
